import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { Switcher } from "ctia-ui";
import { toggleAtlFeeAll } from "actions/catl";

const SwitcherAtlFee = ({ catl, toggleAtlFeeAll }) => {
  const checked = catl && catl.labs && _.every(catl.labs, "atlFeePaid");

  return (
    <Switcher
      show={true}
      labelText="Select All"
      onChange={() => {
        toggleAtlFeeAll(checked);
      }}
      disabled={catl.readOnly}
      checked={checked}
      showWarning={false}
    />
  );
};

function mapStateToProps({ catl }) {
  return { catl };
}

export default connect(mapStateToProps, { toggleAtlFeeAll })(SwitcherAtlFee);
